import React, { useContext } from 'react';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import {
  returnLocale,
  returnCurrencyCharFromCode,
} from '../../../../utils/globals';
import { CheckoutContext } from '../../../../utils/providers/checkout';
import { CartManualUpsellProduct } from '../ManualUpsellProduct/cartManualUpsellProduct';
import { Link } from '../../../UI/Elements/Link';
import { Button } from '../../../UI/Elements';
import { Divider } from '../../../UI/Elements/Divider';
import { useRecoilState } from 'recoil';
import { freeShippingMinState } from '../../../../utils/recoil/zone';

export const CartFooter = ({ footer, body }) => {
  const freeShippingMin = useRecoilState(freeShippingMinState);
  const { checkout, handleLineItemAdd, handleRemoveDiscounts } =
    useContext(CheckoutContext);
  const { subtotalPrice, lineItemsSubtotalPrice, discountApplications } =
    checkout[0];
  const subPrice = lineItemsSubtotalPrice?.attrs?.amount?.value;

  const lineItemSubPrice = lineItemsSubtotalPrice?.attrs.amount.value;
  const isFreeShipping =
    parseFloat(lineItemSubPrice) >= freeShippingMin[0].value;

  const currencyTag = returnCurrencyCharFromCode(checkout[0].currencyCode);
  const isEmptyCart = checkout[0].lineItems?.length === 0;
  const checkoutURL = `${checkout[0].webUrl}&locale=${returnLocale(
    typeof window !== 'undefined' ? window.location.pathname : ''
  )}&cart_id=${checkout[0].id}`;

  const returnSubTotalPrice = () => {
    return (
      <div className='flex justify-between items-center'>
        <Label
          {...footer?.subtotalLabel}
          size='base'
          color={{ classname: 'gray-800' }}
        />
        <div className='flex items-end'>
          <Label
            weight='medium'
            size='base'
            color={{ classname: 'gray-800' }}
            text={`${lineItemsSubtotalPrice.attrs.amount.value}`}
          />
          <Label
            weight='medium'
            size='base'
            text={currencyTag}
          />
        </div>
      </div>
    );
  };

  const returnDiscountedPrice = () => {
    const discountApplication = discountApplications.find((discount) => {
      // TODO CHECK FALSY JAVASCRIPT
      return discount.value.percentage || discount.value.percentage === 0;
    });

    const removeDiscountClick = () => {
      handleRemoveDiscounts();
    };

    if (discountApplication) {
      let discountedValue = Number(
        ((subPrice * discountApplication.value.percentage) / 100).toFixed(1)
      );

      return (
        <div className='flex relative justify-between items-center'>
          <div className='flex'>
            <Label
              {...footer?.discountLabel}
              size='base'
              color={{ classname: 'gray-800' }}
            />
            {discountApplications.map((discount) => {
              // TODO CHECK FALSY JAVASCRIPT
              if (
                discount.value.percentage ||
                discount.value.percentage === 0
              ) {
                return (
                  <div className='flex bg-primary  bg rounded-md p-1 px-2 items-center ml-4'>
                    <Icon
                      iconKey='FaTags'
                      size='sm'
                      color={{ classname: 'white' }}
                    />
                    <span className='ml-1'>
                      <Label
                        {...footer?.subtotalLabel}
                        text={`${discount.code}`}
                        size='sm'
                        transform='capitalize'
                        color={{ classname: 'white' }}
                      />
                    </span>
                    <span className='cursor-pointer ml-1'>
                      <Button
                        size='xs'
                        icon={{
                          iconKey: 'MdClose',
                          color: { classname: 'white' },
                        }}
                        color={{ classname: 'white' }}
                        onClick={removeDiscountClick}
                      />
                    </span>
                  </div>
                );
              }
            })}
          </div>
          <div className='flex items-center'>
            <Label
              {...footer.discountInformationLabel}
              weight='medium'
              size='base'
              color={{ classname: 'gray-800' }}
              // text={`-${discountedValue}`}
            />
            {/* <Label weight="medium" size="lg" text={currencyTag} /> */}
          </div>
        </div>
      );
    }
  };

  const returnShippingPrice = () => {
    const { freeshippingLabel, shippingInformationLabel, shippingLabel } =
      footer;
    return (
      <div className='flex relative justify-between items-center'>
        <Label
          {...footer?.shippingLabel}
          size='base'
          color={{ classname: 'gray-800' }}
        />
        <div className='flex items-end text-right'>
          <Label
            {...shippingInformationLabel}
            text={
              isFreeShipping
                ? freeshippingLabel?.text
                : shippingInformationLabel?.text
            }
            size='sm'
            color={{ classname: 'gray-800' }}
          />
        </div>
      </div>
    );
  };

  const returnTotalPrice = () => (
    <div className='flex pb-4  relative justify-between items-center'>
      <Label
        {...footer?.totalLabel}
        weight='medium'
        size='2xl'
        color={{ classname: 'gray-800' }}
      />
      <div className='flex items-end'>
        <Label
          weight='medium'
          size='2xl'
          color={{ classname: 'gray-800' }}
          text={subtotalPrice?.amount}
        />
        <Label
          weight='medium'
          size='2xl'
          text={currencyTag}
        />
      </div>
    </div>
  );

  return (
    !isEmptyCart && (
      <div className='p-6 pt-2 w-full bg-white'>
        {/* Manual upsell product  */}
        <CartManualUpsellProduct
          handleLineItemAdd={handleLineItemAdd}
          product={body.upsellProduct}
          label={body.label}
        />
        <Divider
          margin='py-2'
          color={'gray-400'}
        />
        {returnSubTotalPrice()}
        {returnDiscountedPrice()}
        {returnShippingPrice()}
        <Divider
          margin='py-2'
          color={'gray-400'}
        />
        {returnTotalPrice()}

        <Link urlLink={checkoutURL}>
          <Button
            htmlType
            type='contained'
            fullWidth
            size='base'
            color={{ classname: 'primary' }}
            label={footer?.checkoutLabel}
            icon={{
              iconKey: 'HiOutlineChevronRight',
              color: { classname: 'white' },
            }}
          />
        </Link>
      </div>
    )
  );
};
